import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectEditAssemblyPage } from '@/areas/assemblies/AssemblyForm/pages/ProjectEditAssemblyPage';
import { assembliesEditModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/assemblies/$assemblyId/edit')({
    staticData: {
        access: { permissions: ['edit:assembly'], modulePermissions: assembliesEditModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ currentParentAssemblyId: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const currentParentAssemblyId = Route.useSearch({ select: (search) => search.currentParentAssemblyId });
    return (
        <ProjectEditAssemblyPage
            projectId={pathParams.projectId}
            assemblyId={pathParams.assemblyId}
            currentParentAssemblyId={currentParentAssemblyId}
        />
    );
}
